import { useStep } from '../hooks/useStep'
import MilestoneScreen from '../components/MilestoneScreen'

export default function ProfileMilestone() {
  useStep({})

  return (
    <MilestoneScreen
      title="Your organisation profile is ready!"
      description="Great work! We've built a profile for your organisation. Next, we'll set up your funding request so we can start finding matches."
    />
  )
}
